import React, {useEffect} from 'react'
import { connect } from 'react-redux'
import {setVisibleState, fetchCartItems, fetchInCart, delCartItem, addToCart} from '../actions/cartDropdowIconActions'
import CartDropdownProduct from './cartDropdownProduct'
import {bindActionCreators} from "redux";


const CartDropdownIcon  = props => {

    const { dropdowncart, dropdownitems, setVisibleState, fetchCartItems, fetchInCart, delCartItem} = props
    let className = 'ncartdropdown';
    className = (dropdowncart.status==='CLOSED') ? (className += ' closed') : (className += ' opened')
    const hasProducts = dropdownitems.items.length > 0
    const show_loader =  (dropdownitems.status === "LOADING") ? true : false

    useEffect(() => {

        fetchInCart();

    }, [])

    useEffect(() => {

        if(dropdowncart.incart_status==="LOADED"){

            let inCartUpdatedEvent = new CustomEvent("NcartInCartUpdated", {detail: dropdowncart.incart});
            document.dispatchEvent(inCartUpdatedEvent);

        }

    }, [dropdowncart.incart])

    useEffect(() => {
        if (dropdowncart.status==="OPENED"){

            fetchCartItems();

        }
    }, [dropdowncart.status])


    const error_message = (dropdownitems.status === "ERROR") ? (
        <div className="ncart-error">Ошибка загрузки данных</div>
    ) : null


    const nodes = hasProducts ? (
        dropdownitems.items.map(item =>
          <CartDropdownProduct
            title={item.title}
            total={item.total}
            unit={item.unit}
            unit_step={item.unit_step}
            quantity={item.quantity}
            link = {item.link}
            key={item.id}
            delFunction={() => delCartItem(item.id)}
          />
        )
    ) : (
        <div className="ncart-empty">Ваша корзина пока пуста</div>
    )

    return (
        <div className={className}
        onMouseEnter={() => setVisibleState("OPENED")}
        onMouseLeave={() => setVisibleState("CLOSED")}>
            <div className="ncartdropdown-main">
                <i className="material-icons">shopping_cart</i>
                <span className="ncart-badge">{dropdowncart.total_quantity}</span>
            </div>
            <div className="ncartdropdown-items">
                {error_message}
                {show_loader ? (
                    <div className="ncartdropdown-items-loader">
                    <div className="preloader pl-size-xs">
                        <div className="spinner-layer pl-red-grey">
                            <div className="circle-clipper left">
                                <div className="circle"></div>
                            </div>
                            <div className="circle-clipper right">
                                <div className="circle"></div>
                            </div>
                        </div>
                    </div></div>
                ): (nodes)}
                <hr/>
                <div className="ncart-total">
                    <span className="total-title">Итого</span>
                    <span className="total-price">{dropdowncart.total}&nbsp;&#8381;</span>
                </div>
                <div className="ncart-button-block">
                    <a href="/shop/ncart/" className="button ncart-button">ПЕРЕЙТИ В КОРЗИНУ</a>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    dropdowncart: state.dropdowncart,
    dropdownitems: state.dropdownitems
})

const mapDispatchToProps = dispatch => bindActionCreators({
    setVisibleState, fetchCartItems, fetchInCart, delCartItem, addToCart }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CartDropdownIcon)
